import React from 'react';
import {
  ErrorOutline,
  InfoOutlined,
  WarningAmberOutlined,
} from '@mui/icons-material';

import { HealthCheckSeverity } from './types';

/**
 * Darstellung einer Stufe im Health-Check-Dialog (#1283).
 *
 * Rein visuell. Welche Stufe ein Fund hat, entscheidet weiterhin die
 * Regelkonfiguration — hier steht nur, wie sie aussieht.
 *
 * Die Farbe kommt als Palettenschlüssel, nicht als Farbwert: die Kanzlei-Farben
 * stehen im Theme und werden zur Laufzeit aus der Konfiguration gesetzt
 * (`App.tsx`). Ein fester Hexwert würde daran vorbeigehen.
 */
export const SEVERITY_PALETTE: Record<
  HealthCheckSeverity,
  'error' | 'warning' | 'info'
> = {
  error: 'error',
  warning: 'warning',
  info: 'info',
};

/** Kurzform für den Chip an einer Prüfung. */
export const SEVERITY_LABEL: Record<HealthCheckSeverity, string> = {
  error: 'Fehler',
  warning: 'Warnung',
  info: 'Hinweis',
};

/**
 * Symbol je Stufe. Bisher lieferte die `Alert`-Komponente diese Icons selbst;
 * mit der eigenen Fundzeile müssen sie hier stehen — dieselben Symbole, damit
 * sich für den Leser nichts ändert.
 */
export const severityIcon = (
  severity: HealthCheckSeverity
): React.ReactElement => {
  if (severity === 'error') {
    return <ErrorOutline fontSize='small' />;
  }

  if (severity === 'warning') {
    return <WarningAmberOutlined fontSize='small' />;
  }

  return <InfoOutlined fontSize='small' />;
};
